import "../styles.css";
import logo from '../assets/logo.png';
import { useTypewriter, Cursor } from 'react-simple-typewriter';
import 'react-simple-typewriter/dist/index'

const Home = ({ scroll, works, lightMode }) => {

    const [text] = useTypewriter({
        words: ['Web-Development', 'Web3', 'Cyber-Security'],
        loop: true,
        typeSpeed: 120,
        deleteSpeed: 180
    })

    return (
        <div className={"home " + (lightMode ? 'light-primary' : 'dark-primary')}>
            <img className="overlay" src={logo} alt="" />
            <div className="home-content">
                <div className={"home-title " + ("dark-mode " + (lightMode ? 'logo-dark' : ''))}>
                    BLUEJAG
                </div>
                <div className="home-sub-title">
                    <span>
                        {text}
                        <Cursor cursorBlinking={true} cursorStyle='|' />
                    </span>
                </div>

                <div className={"home-desc " + ("dark-mode " + (lightMode ? 'logo-dark' : ''))}>
                    <p>
                        We offer a wide range of exceptional services including design
                        of stunning and functional websites, securing and protecting already existing
                        websites and networks and building Web3 web apps.
                    </p>
                </div>

                <div onClick={() => scroll(works)} className="home-btn">
                    See our works
                </div>
            </div>
        </div>
    )
}

export default Home
